export default __webpack_public_path__ + "static/media/testimonial.3be39397.jpg";